(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    function initEtoileBackgroundVideos(root) {
    const videos = root.querySelectorAll('[data-etoile-deferred-video]');
    const load = video => {
      video.querySelectorAll('source[data-etoile-video-src]').forEach(source => {
        source.src = source.dataset.etoileVideoSrc;
        source.removeAttribute('data-etoile-video-src');
      });
      video.removeAttribute('data-etoile-deferred-video');
      video.muted = true;
      video.autoplay = true;
      video.load();
      const playback = video.play();
      if (playback) playback.catch(() => {});
    };
    if (!('IntersectionObserver' in window)) { videos.forEach(load); return; }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
      });
    }, {rootMargin:'300px'});
    videos.forEach(video => observer.observe(video));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initEtoileBackgroundVideos(document), {once:true});
  } else { initEtoileBackgroundVideos(document); }
  document.addEventListener('shopify:section:load', event => initEtoileBackgroundVideos(event.target));
  } catch(e) { console.error(e); }
})();

})();
